<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.Number" clearable></el-input>
      </el-form-item>
      <el-form-item label="聚能谷桩名">
        <el-input placeholder="请输入聚能谷桩名" v-model="filter.EName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column label="资产码" prop="NumberBox" width="220" align="center">
        <template slot-scope="{ row }">
          <div class="show_assets_code" @click="showTripletDetail(row.NumberBox)">{{ row.NumberBox }}</div>
        </template>
      </el-table-column>
      <el-table-column label="充电桩名" prop="name"></el-table-column>
      <el-table-column label="聚能谷桩名" prop="EName"></el-table-column>
      <el-table-column label="所属分支箱" prop="branch_box_name"></el-table-column>
      <!-- <el-table-column label="生产厂家" prop="charge_pile_producer_name"></el-table-column> -->
      <el-table-column label="相别" prop="term" width="60px"></el-table-column>
      <el-table-column label="费控表地址" prop="fee_table_address"></el-table-column>
      <!-- <el-table-column label="描述" prop="remark"></el-table-column> -->
      <el-table-column label="创建时间" prop="create_time"></el-table-column>
      <el-table-column label="修改时间" prop="modify_time"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="140px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增or修改充电充电桩 -->
    <el-dialog :visible.sync="visible.editGroup" :title="isUpdate ? $t('groupmanage.editortitle') : $t('groupmanage.appendtitle')" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="充电桩名" prop="name" label-width="20%">
              <el-input placeholder="请输入充电充电桩名" v-model="form.name" maxlength="30" show-word-limit />
            </el-form-item>

            <el-row type="flex" justify="left" class="custom-label">
              <el-col :span="16">
                <el-form-item label="聚能谷桩名" prop="EName" label-width="30%">
                  <div @click="onSelectPile">
                    <el-input :disabled="isUpdate" v-model="form.EName" readonly placeholder="请选择聚能谷桩" suffix-icon="el-icon-more"></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="相别" prop="term">
                  <el-select v-model="form.term">
                    <el-option v-for="item in termItems" :label="item.label" :value="item.Id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="所属分支箱" prop="power_branch_box_id" label-width="20%">
              <el-select v-model="form.power_branch_box_id" placeholder="请选择所属分支箱" style="width: 100%" clearable filterable>
                <el-option v-for="item in branchBoxOptions" :key="item.ID" :label="item.name" :value="item.ID">
                  <span style="float: left">{{ item.name }}</span>
                  <!-- <span style="float: right; color: #8492a6; font-size: 13px">
                    地址: {{ item.address }}
                  </span> -->
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="充电桩生产厂家" prop="charge_pile_producer_id" label-width="20%">
              <el-select v-model="form.charge_pile_producer_id" placeholder="请选择充电桩生产厂家" style="width: 100%" clearable filterable>
                <el-option v-for="item in producerOptions" :key="item.ID" :label="item.name" :value="item.ID">
                  <span style="float: left">{{ item.name }}</span>
                  <!-- <span style="float: right; color: #8492a6; font-size: 13px">
                     {{ item.address }}
                  </span> -->
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="费控表地址" prop="fee_table_address" label-width="20%" requ>
              <el-row type="flex" justify="center">
                <el-col :span="18">
                  <el-input placeholder="请输入费控表地址" v-model="form.fee_table_address" />
                </el-col>
                <el-col :span="6" style="color: #999"> 　统建统服桩必填 </el-col>
              </el-row>
            </el-form-item>

            <el-form-item label="地址" prop="address" label-width="20%">
              <el-input placeholder="请输入地址" v-model="form.address" />
            </el-form-item>
            <el-form-item label="描述" prop="remark" label-width="20%">
              <el-input placeholder="请输入描述" v-model="form.remark" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editGroup = false">{{ $t("groupmanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t("groupmanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>
    <!-- 充电充电桩选择框 -->
    <select-pile :show.sync="visible.pile" @confirm="confirmSelectpile"></select-pile>
    <tripletDetail ref="tripletDetail"></tripletDetail>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import selectPile from "./components/select-pile.vue"
import tripletDetail from "../control/_triplet_detail.vue"
import { getPowerChargePileList, getChargePileProducerList, modifyPowerChargePile, delPowerChargePile, addPowerChargePile, getPowerBranchBoxList } from "@/api/dev_archive"
import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { selectPile, tripletDetail },
  data() {
    return {
      visible: {
        editGroup: false,
        pile: false
      },
      tableData: [],
      termItems: [
        { label: "A相", Id: "A" },
        { label: "B相", Id: "B" },
        { label: "C相", Id: "C" }
      ],
      form: {
        name: "",
        EName: "",
        maindba_equipmentbox_id: "",
        power_branch_box_id: "",
        charge_pile_producer_id: "",
        term: "",
        address: "",
        remark: ""
      },
      branchBoxOptions: [], // 分支箱选项数组
      producerOptions: [], // 充电桩生产厂家选项数组
      formRules: {},
      filter: {
        Number: "",
        EName: ""
      },
      loading: false,
      isUpdate: true,
      gid: "" // 充电充电桩ID
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.formRules = {
      power_branch_box_id: [{ required: true, message: "请选择所属分支箱", trigger: "change" }],
      charge_pile_producer_id: [{ required: true, message: "请选择充电桩生产厂家", trigger: "change" }],
      EName: [{ required: true, message: "请选择充电桩", trigger: "change" }],
      //fee_table_address: [{ required: true, message: "请输入费控表地址", trigger: "change" }],//只有统建统服的桩必填
      name: [{ required: true, message: "请填写充电桩名", trigger: "change" }]
    }

    // 加载分支箱数据和充电桩生产厂家数据并初始化表格数据
    Promise.all([this.loadBranchBoxOptions(), this.loadProducerOptions()]).then(() => {
      this.getData()
    })
  },
  methods: {
    showTripletDetail(assetsCode) {
      this.$refs.tripletDetail.showTripletInfo(assetsCode)
    },
    // 加载分支箱选项
    loadBranchBoxOptions() {
      return getPowerBranchBoxList({ pagesize: 100000 })
        .then((res) => {
          if (res && res.data) {
            this.branchBoxOptions = res.data.filter((item) => !item.del)
            return this.branchBoxOptions
          }
          return []
        })
        .catch((error) => {
          this.$message.error("加载分支箱列表失败")
          return []
        })
    },

    // 加载充电桩生产厂家选项
    loadProducerOptions() {
      return getChargePileProducerList({ pagesize: 100000 })
        .then((res) => {
          if (res && res.data) {
            this.producerOptions = res.data.filter((item) => !item.del)
            return this.producerOptions
          }
          return []
        })
        .catch((error) => {
          this.$message.error("加载充电桩生产厂家列表失败")
          return []
        })
    },

    async onUpdate(row) {
      this.visible.editGroup = true
      this.isUpdate = true

      // 确保分支箱和生产厂家数据已加载
      if (!this.branchBoxOptions.length) {
        await this.loadBranchBoxOptions()
      }
      if (!this.producerOptions.length) {
        await this.loadProducerOptions()
      }

      this.form.name = row.name
      this.form.EName = row.EName
      this.form.maindba_equipmentbox_id = row.maindba_equipmentbox_id
      this.form.power_branch_box_id = row.power_branch_box_id
      this.form.term = row.term
      this.form.address = row.address
      this.form.fee_table_address = row.fee_table_address
      this.form.remark = row.remark
      this.gid = row.ID

      // 设置充电桩生产厂家名称
      this.form.charge_pile_producer_id = row.charge_pile_producer_id
    },

    onDelete(row) {
      this.$confirm("确定要删除该充电桩吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delPowerChargePile(row).then((res) => {
            this.$message.success(`删除成功`)
            this.toFilter()
          })
        })
        .catch(() => {})
    },

    confirmSelectpile(item) {
      this.visible.pile = false
      this.form.maindba_equipmentbox_id = item.ID
      this.form.EName = item.EName
    },

    onSelectPile() {
      if (this.isUpdate) {
        return
      }
      this.visible.pile = true
    },

    getData() {
      this.loading = true
      getPowerChargePileList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        asset_code: this.filter.Number || null,
        name: this.filter.EName || null
      })
        .then((res) => {
          // 创建分支箱映射表
          const branchBoxMap = {}
          this.branchBoxOptions.forEach((branchBox) => {
            branchBoxMap[branchBox.ID] = branchBox.name || branchBox.address || branchBox.ID
          })

          // 创建生产厂家映射表
          const producerMap = {}
          this.producerOptions.forEach((producer) => {
            // 使用ID作为key，name作为value
            producerMap[producer.ID] = producer.name
          })

          // 处理表格数据
          this.tableData = res.data.map((item) => {
            return {
              ...item,
              branch_box_name: branchBoxMap[item.power_branch_box_id] || item.power_branch_box_id,
              // 显示生产厂家名称，如果映射不到则显示原始值
              charge_pile_producer_name: producerMap[item.charge_pile_producer_id] || item.charge_pile_producer_id
            }
          })
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },

    async onAdd() {
      this.visible.editGroup = true
      this.isUpdate = false
      this.form = this.$options.data().form

      // 确保分支箱和生产厂家数据已加载
      if (!this.branchBoxOptions.length) {
        await this.loadBranchBoxOptions()
      }
      if (!this.producerOptions.length) {
        await this.loadProducerOptions()
      }
    },

    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          const reqData = {
            name: this.form.name,
            maindba_equipmentbox_id: this.form.maindba_equipmentbox_id,
            power_branch_box_id: this.form.power_branch_box_id,
            charge_pile_producer_id: this.form.charge_pile_producer_id,
            term: this.form.term,
            address: this.form.address,
            fee_table_address: this.form.fee_table_address,
            remark: this.form.remark
          }

          if (this.isUpdate) {
            reqData.ID = this.gid
            modifyPowerChargePile(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addPowerChargePile(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
